import { provideChameleonDesignSystem } from '../../provideChameleonDesignSystem';
import { chameleonDataTableHeaderV2 } from './DataTableHeaderV2.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonDataTableHeaderV2({ prefix }));
}
